const { makeStyles } = require('@material-ui/core');

const useCommonStyles = makeStyles(() => ({
  fontLarge: {
    color: (props) => (props.mode === 'dark' ? '#FFF' : '#252525'),
    fontSize: 36,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '44px',
  },
  fontMediumBold: {
    color: (props) => (props.mode === 'dark' ? '#FFF' : '#252525'),
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '22px',
  },
  fontMedium: {
    color: (props) => (props.mode === 'dark' ? '#A3A4B6' : '#DBDBDB'),
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '28px',
  },
  fontRegular: {
    color: (props) => (props.mode === 'dark' ? '#FFF' : '#252525'),
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
  },
  fontRegularLight: {
    color: (props) => (props.mode === 'dark' ? '#A3A4B6' : '#7D7D7D'),
    fontSize: 14,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
  },
  fontSmall: {
    color: (props) => (props.mode === 'dark' ? '#FFF' : '#252525'),
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '16px',
  },
}));

export { useCommonStyles };
